import React from 'react';
import { Alert } from 'antd';
import NonStdSnapshotView from '../../../nonstandard-ops/NonStdSnapshotView';
import NonStdWorkbench from '../../../nonstandard-ops/NonStdWorkbench';

type Props = {
  instructionDetail?: any;
  step?: any;
};

/**
 * 库存非标准操作 · 执行记录步骤：自由记录做了什么（文字/照片/附件/视频），一个开关决定客户能不能看到。
 * 需要客户确认时点"提交本轮结果，请客户反馈"（这一步不结束本阶段），客户回复后继续记录；
 * 所有事情都处理完，点页面右上角的"提交记录并完成本阶段"（所有模板通用的按钮）结束执行阶段。
 * 这里完全看不到收费：收费由管理员在终审时确定。
 */
const NonStdRecordRenderer: React.FC<Props> = ({ instructionDetail, step }) => {
  const instructionId = Number(instructionDetail?.id || 0);
  if (!instructionId) return null;
  // 本阶段已提交：显示提交时固化的快照（只读），不能再新增、修改记录和标签
  if (String(step?.status || '') === 'done') {
    const snapshot = step?.collected_metrics?.nonstd_snapshot;
    if (snapshot) return <NonStdSnapshotView snapshot={snapshot} />;
    return (
      <div style={{ width: '100%' }}>
        <Alert type="warning" showIcon style={{ marginBottom: 8 }} message="本阶段已提交（没有快照，可能是更早之前提交的），以下是当前内容，只读。" />
        <NonStdWorkbench instructionId={instructionId} mode="view" />
      </div>
    );
  }
  return (
    <div style={{ width: '100%' }}>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 8 }}
        message={'此类指令没有固定流程，请直接记录操作的结果，如表格/照片/视频等。需要客户确认时点“提交本轮结果，请客户反馈”，客户回复后继续记录；全部处理完再点“提交记录并完成本阶段”。'}
      />
      <NonStdWorkbench instructionId={instructionId} mode="execute" />
    </div>
  );
};

export default NonStdRecordRenderer;
